import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectClosingPortal = createSelector(getSystem, ({ closingPortal }) => closingPortal);

export const selectClosingPortalLoans = createSelector(selectClosingPortal, ({ loans }) => loans);

export const selectClosingPortalLoanSummary = createSelector(
  selectClosingPortal,
  ({ loanSummary }) => loanSummary,
);

export const selectClosingPortalWireInstructions = createSelector(
  selectClosingPortal,
  ({ wireInstructions }) => wireInstructions,
);

export const selectClosingPortalFees = createSelector(selectClosingPortal, ({ fees }) => fees);

export const selectClosingPortalFeeTypes = createSelector(
  selectClosingPortal,
  ({ feeTypes }) => feeTypes?.feeTypes ?? null,
);

export const selectClosingPortalFeeRecommendations = createSelector(
  selectClosingPortal,
  ({ feeRecommendations }) => feeRecommendations,
);

export const selectClosingPortalDocuments = createSelector(
  selectClosingPortal,
  ({ documents }) => documents,
);

export const selectClosingPortalDraftFeeRecommendations = createSelector(
  selectClosingPortal,
  ({ draftFeeRecommendations }) => draftFeeRecommendations,
);
